export default {"src":"/_next/static/media/kijiji-logo-white.b293145f.svg","height":39,"width":59,"blurWidth":0,"blurHeight":0};